import React, {useState} from "react";
import {Card, Col, Row} from "react-bootstrap";

import Arrow from "../Arrow/Arrow";
import MeasurementText from "../MeasurementText/MeasurementText";
import {getMonthLabel} from "../Utils/utils";

export default function LeakCost(props) {
    const leakCostLabelCurrent = getMonthLabel(props.data.cost.currentDate);
    const currencyUnit = props.currencyUnit;
    const leakCostPrevLabel = getMonthLabel(props.data.cost.increaseDate);
    const leakCostPercent = props.data.cost.increaseValue;
    const isPositive = !leakCostPercent > 0;
    const positiveLeakCostPercent = isPositive ? leakCostPercent : leakCostPercent * -1;
    const leakCost = Number(props.data.cost.current);
    const carbonEmission = props.data.cost.carbonEmission

    return (
        <Card style={{height: '272px'}}>
            <Card.Body>
                <Card.Text>
                    <Row>
                        <Col md={6}>
                            <Row>
                                <Col>
                                    <Card.Title style={{fontWeight: 'bold'}}>Savings</Card.Title>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Card.Subtitle className={'text-muted'}>{leakCostLabelCurrent}</Card.Subtitle>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Card.Text style={{marginTop: '18px'}}><MeasurementText value={Math.ceil(leakCost)} unit={currencyUnit}/></Card.Text>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={6}>
                            <Row>
                                <Col>
                                    <Card.Title className={'bold-title'}>Carbon Emissions</Card.Title>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Card.Subtitle className={'text-muted'}>{leakCostLabelCurrent}</Card.Subtitle>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Card.Text style={{marginTop: '18px'}}><MeasurementText value={Math.ceil(carbonEmission)} unit={'TONS'}/></Card.Text>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card.Text>
                <hr/>
                <Card.Text>
                    <Row style={{marginTop: '4px', marginBottom: '4px'}}>
                        <Col>
                            <Row>
                                <Col>
                                    <Card.Subtitle className={'text-muted'}>Compared to {leakCostPrevLabel}</Card.Subtitle>
                                </Col>
                            </Row>
                            <Row style={{marginTop: '18px', marginBottom: '0px'}}>
                                <Col>
                                    <p style={{fontSize: 'x-large', marginBottom: '0px'}}>
                                        <Arrow isColored={true} isPositive={isPositive}/>{positiveLeakCostPercent.toLocaleString() || 0}%
                                    </p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card.Text>
            </Card.Body>
        </Card>
    )
}